<template>
    <div class="paypal-balance-page">
        <div class="header">
            <el-date-picker v-model="searchDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                size="small" style="width:150px;margin-right:10px;" @change="getList" />
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success"  v-loading="syncLoading" @click="handleSync">手动同步余额</el-button>
        </div>

        <el-table :data="tableData" border stripe v-loading="loading" style="width:100%;">
            <el-table-column label="序号" type="index" align="center" ></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="{row}">
                    <el-table :data="row.balances" border size="mini">
                        <el-table-column prop="currency" label="币种" width="100" align="center">
                            <template slot-scope="{row:item}">
                                <span>{{ item.currency }}</span>
                                <el-tag v-if="item.isPrimary == 1" type="success" size="mini"
                                    style="margin-left:5px;">主币种</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="原总余额" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(item.totalBalance) }} {{ item.currency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="原可用余额" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(item.availableBalance) }} {{ item.currency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="原不可用余额" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(item.withheldBalance) }} {{ item.currency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="汇率" align="right">
                            <template slot-scope="{row:item}">
                                1 {{ item.currency }} = {{ formatRate(getConvertRate(item.currency,
                                row.primaryCurrency)) }} {{ row.primaryCurrency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="转USD总余额" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(convertToPrimary(item.totalBalance, item.currency, row.primaryCurrency)) }} {{
                                row.primaryCurrency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="转USD可用余额" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(convertToPrimary(item.availableBalance, item.currency, row.primaryCurrency)) }}
                                {{ row.primaryCurrency }}
                            </template>
                        </el-table-column>

                        <el-table-column label="转USD不可用" align="right">
                            <template slot-scope="{row:item}">
                                {{ money(convertToPrimary(item.withheldBalance, item.currency, row.primaryCurrency)) }}
                                {{ row.primaryCurrency }}
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>

            <el-table-column prop="accountName" label="PayPal账户" min-width="180" align="center" />

            <el-table-column prop="primaryCurrency" label="主币种" width="100" align="center">
                <template slot-scope="{row}">
                    <el-tag type="success">{{ row.primaryCurrency }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="总余额" min-width="160" align="right">
                <template slot-scope="{row}">
                    <b>{{ money(getTotalBalance(row)) }} {{ row.primaryCurrency }}</b>
                </template>
            </el-table-column>

            <el-table-column label="可用余额" min-width="160" align="right">
                <template slot-scope="{row}">
                    <span style="color:#67c23a;font-weight:bold;">{{ money(getAvailableBalance(row)) }} {{
                        row.primaryCurrency }}</span>
                </template>
            </el-table-column>

            <el-table-column label="不可用余额" min-width="160" align="right">
                <template slot-scope="{row}">
                    <span style="color:#e6a23c;font-weight:bold;">{{ money(getWithheldBalance(row)) }} {{
                        row.primaryCurrency }}</span>
                </template>
            </el-table-column>
            <el-table-column label="PayPal余额时间" width="170" align="center">
                <template slot-scope="{row}">
                    {{ formatDateTime(row.asOfTime) }}
                </template>
            </el-table-column>

            <el-table-column label="PayPal刷新时间" width="170" align="center">
                <template slot-scope="{row}">
                    {{ formatDateTime(row.lastRefreshTime) }}
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="拉取日期" width="120" align="center" />
        </el-table>
    </div>
</template>

<script>
import { ajaxPost, Baseurl, ajaxGet } from "@/api/api/api";

export default {
    name: "PaypalBalance",
    data() {
        return {
            loading: false,
            syncLoading: false,
            searchDate: "",
            tableData: [],
            rateList: []
        };
    },
    created() {
        this.searchDate = this.getToday();
        this.getRateList();
        this.getList();
    },
    methods: {
        getRateList() {
            const url = Baseurl + "rateController/getAllRate";
            ajaxGet(url).then(res => {
                if (res.data.code == 200) {
                    this.rateList = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg || "获取汇率失败");
                }
            });
        },
        getRate(currencyCode) {
            if (currencyCode === "CNY") return 1;
            const item = this.rateList.find(item => item.currencyCode === currencyCode);
            return item ? Number(item.exchangeRate || 0) : 0;
        },
        formatDateTime(value) {
            if (!value) return "-";
            const date = new Date(value);
            if (isNaN(date.getTime())) return value;
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, "0");
            const d = String(date.getDate()).padStart(2, "0");
            const h = String(date.getHours()).padStart(2, "0");
            const min = String(date.getMinutes()).padStart(2, "0");
            const s = String(date.getSeconds()).padStart(2, "0");
            return y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
        },
        getList() {
            this.loading = true;
            const url = Baseurl + "paypalAccountController/getBalanceList";
            ajaxPost(url, { date: this.searchDate }).then(res => {
                if (res.data.code == 200) {
                    console.log(res.data);
                    this.tableData = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg || "查询失败");
                }
            }).catch(err => {
                console.error(err);
                this.$message.error("查询PayPal余额失败");
            }).finally(() => {
                this.loading = false;
            });
        },

        handleSync() {
            this.syncLoading = true;
            const url = Baseurl + "paypalAccountController/syncBalance";
            ajaxPost(url, {}).then(res => {
                if (res.data.code == 200) {
                    this.$message.success("PayPal余额同步完成");
                    this.searchDate = this.getToday();
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "同步失败");
                }
            }).catch(err => {
                console.error(err);
                this.$message.error("PayPal余额同步失败");
            }).finally(() => {
                this.syncLoading = false;
            });
        },

        convert(amount, rate) {
            const value = Number(amount || 0);
            const exchangeRate = Number(rate || 0);
            return value * exchangeRate;
        },

        getTotalBalance(row) {
            return (row.balances || []).reduce((total, item) => {
                return total + this.convertToPrimary(item.totalBalance, item.currency, row.primaryCurrency);
            }, 0);
        },

        getAvailableBalance(row) {
            return (row.balances || []).reduce((total, item) => {
                return total + this.convertToPrimary(item.availableBalance, item.currency, row.primaryCurrency);
            }, 0);
        },

        getWithheldBalance(row) {
            return (row.balances || []).reduce((total, item) => {
                return total + this.convertToPrimary(item.withheldBalance, item.currency, row.primaryCurrency);
            }, 0);
        },


        getConvertRate(currency, primaryCurrency) {
            if (currency === primaryCurrency) return 1;
            const currencyRate = this.getRate(currency);
            const primaryRate = this.getRate(primaryCurrency);
            if (currencyRate === 0 || primaryRate === 0) return 0;
            return currencyRate / primaryRate;
        },
        convertToPrimary(amount, currency, primaryCurrency) {
            return Number(amount || 0) * this.getConvertRate(currency, primaryCurrency);
        },

        formatRate(value) {
            if (value === null || value === undefined) return "-";
            return Number(value).toFixed(6);
        },

        money(value) {
            return Number(value || 0).toFixed(2);
        },
       

        getToday() {
            const date = new Date();
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, "0");
            const d = String(date.getDate()).padStart(2, "0");
            return y + "-" + m + "-" + d;
        }
    }
};
</script>

<style scoped>
.paypal-balance-page {
    padding: 20px;
    background: #fff;
}

.header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}
</style>